<template>
  <div class="nl-edit" v-if="(typeof $teras.evento.id != 'undefined')">
      <!-- 
      <div class="row " style="margin-top:40px;">
        <div class="col s12 m3">&#160;</div>
        <div class="col s12 m6"><el-button type="primary" @click="onNew" style="width:100%;">Invia nuovo Abstract</el-button></div>
        <div class="col s12 m3"></div>
      </div
      -->

     <el-form ref="isAbs" :model="$abs.row" v-on:submit.prevent="preview" :rules="rules" label-width="180px">


<div v-if="!$teras.preview">

<div  v-if="$abs.row.step==0">

  <h4 class="yo-color-secondary" v-html="$teras.lang.lineeguidaSection"></h4>
  <div class="row row-form" >
    <div class="col s10 offset-s2" v-html="$teras.evento.lineeguida"></div>
  </div>


  <el-form-item >
  <el-checkbox v-model="$abs.lineeguida" true-label="1"  false-label="0" ><span v-html="$teras.lang.lineeguidaCheck"></span></el-checkbox>
  </el-form-item>


</div>

<h4 class="yo-color-secondary" v-html="$teras.lang.datipresentatoreSection"></h4>
<div v-if="$abs.lineeguida>0">
  <div class="row pad help">
    <div class="col s2 yo-align-right"><i class="material-icons">live_help</i></div>
    <div class="col s10" v-html="$teras.lang.datipresentatoreHelp"></div>
  </div>
  <absPresentatore  ></absPresentatore>
</div>


<h4 class="yo-color-secondary" v-html="$teras.lang.affiliazioniSection"></h4>
<div v-if="$abs.row.prnome!='' && $abs.row.prcognome!='' && $abs.row.premail!=''">
  <div class="row pad help">
    <div class="col s2 yo-align-right"><i class="material-icons">live_help</i></div>
    <div class="col s10" v-html="$teras.lang.affiliazioniHelp"></div>
  </div>
  <absAffiliazioni ></absAffiliazioni>
</div>

<h4 class="yo-color-secondary" v-html="$teras.lang.autoriSection"></h4>
<div v-if="$teras.affiliazioni.length>0">
  <div class="row help">
    <div class="col s2 yo-align-right"><i class="material-icons">live_help</i></div>
    <div class="col s10" v-html="$teras.lang.autoriHelp"></div>
  </div>
  <absAutori v-if="$teras.affiliazioni.length>0" ></absAutori>
</div>

<h4 class="yo-color-secondary" v-html="$teras.lang.paSection"></h4>
<absPrimoautore v-if="$teras.autori.length>0" ></absPrimoautore> 


<h4 class="yo-color-secondary" v-if="$teras.evento.poster==1 || $teras.evento.comunicazione==1" v-html="$teras.lang.datiabsSection"></h4>
<absPoster v-if="$abs.row.paemail!='' && $abs.row.pacellulare!=''" ></absPoster> 

<h4 class="yo-color-secondary" v-if="$teras.evento.finanziamenti==1" v-html="$teras.lang.finanziamentiSection"></h4>
<absFinanziamenti v-if="$teras.evento.finanziamenti==1 && $abs.row.paemail!='' && $abs.row.pacellulare!=''"  ></absFinanziamenti> 

<h4 class="yo-color-secondary" v-html="$teras.lang.testoSection"></h4>
<absTesto v-if="$abs.row.paemail!='' && $abs.row.pacellulare!=''" ></absTesto>





</div>





<!--
<h4 class="yo-color-secondary">TESTO</h4>
      <el-form-item v-if="$abs.row.pa>-1"  :label="$teras.lang.titolo" prop="titolo">
        <el-input placeholder="indicare il titolo per abstract" v-model="form.titolo"></el-input>
      </el-form-item>

      <el-form-item v-if="$abs.row.titolo.length>10"  :label="$teras.lang.testo">
          <tinymce v-model="form.testo" height="300" :language="$teras.language" v-on:change="testoChange"> </tinymce>
      </el-form-item>
-->
<!-- -->
    
<h4 class="yo-color-secondary" v-html="$teras.lang.previewSection"></h4>
<div v-if="$abs.row.wordcount>1 && $abs.row.wordcount<$teras.evento.maxparole+1 ">
  <div class="row pad help" v-if="!$teras.preview">
    <div class="col s2 yo-align-right"><i class="material-icons">live_help</i></div>
    <div class="col s10"><div v-html="$teras.lang.previewHelp"></div>
    <el-button type="primary" @click="onPreview" style="margin:16px 0 0 0;width:100%;">Preview</el-button>
    </div>
  </div>
  <a :href="urlPreview" target="_blank" ref="linkPreview" style="display:none;">Preview</a>

  
  <div class="row pad">
    <div class="col s12 m4">
      

      <div class="" v-if="$teras.preview" style="margin:0;">
        <div v-html="$teras.lang.previewCheckHelp" style="margin:0 0 20px 0;"></div>
        <el-checkbox v-model="preview" true-label="1"  false-label="0">{{$teras.lang.previewCheck}}</el-checkbox>
        <br /><br />
        <el-button style="width:100%;" @click="onChange">{{$teras.lang.modifica}}</el-button>
      </div>

      <div class="" v-if="preview>0" style="margin:80px 0;">
        <div v-html="$teras.lang.previewCheckedHelp" style="margin:0 0 20px 0;"></div>    
        <el-button type="primary" @click="Save" style="width:100%;">{{$teras.lang.salvainvia}}</el-button>
      </div>

      <div class="" v-if="$teras.preview && $abs.row.step==1 " style="margin:80px 0;">
        <el-button type="success" @click="saveNoEmail" style="width:100%;">SALVA SENZA INVIARE EMAIL</el-button>
      </div>

    </div>
    <div class="col s12 m8"><el-pdf v-if="$teras.preview " :pdfPath="$abs.urlPreview"></el-pdf></div>
    
  </div>

 
  

  
  
  
</div>

    


    </el-form>



  </div>
</template>

<script>
import elPdf from './Pdf-desktop.vue'

import absPresentatore from './Abs-presentatore.vue'
import absAffiliazioni from './Abs-affiliazioni.vue'
import absAutori from './Abs-autori.vue'
import absPrimoautore from './Abs-primoautore.vue'
import absPoster from './Abs-poster.vue'
import absTesto from './Abs-testo.vue'
import absFinanziamenti from './Abs-finanziamenti.vue'


import draggable from 'vuedraggable'

var moment = require('moment');
moment.locale('it');

export default {
  name: 'abs-news',
  components: {
    elPdf,
    absPresentatore,
    absAffiliazioni,
    absAutori,
    absPrimoautore,
    absPoster,
    absTesto,
    absFinanziamenti,
    draggable
  },
  mounted (){
    var parent = this
    /*
    this.timeBozza = setInterval(function(){
      parent.Bozza()
    }, 60000)
    */
  },
  destroyed(){
    clearInterval(this.timeBozza);
  },
  created () {
    console.log("Arrivo al abs-new.vue");
    console.log(navigator)
    var parent = this



/*
    var args = {idAbs: 5, sendto:'', lingua:'ita'}
    this.$soap.get('Ws/bamsEmail<h4 class="yo-color-secondary" v-html="$teras.lang.lineeguidaSection"></h4>AbsInserito',{params: args})
        .then(function (response) {
          console.log('RESPONSE')
          console.log(response.esito)
        })
        .catch(function (error) {
          console.log('ERRORE')
          console.log(response)
        })
*/



    /*
    this.axios.get('api/vue/options/',{})
      .then(function (response) {  
        var api = response.data
        if (api.esito) {
          parent.templates = api.data.templatesDP
          parent.destinatariDP = api.data.destinatariDP
        }
        
      })
      */
    //this.form = this.$store.state.nl;
  },
  data() {
    return {
      timeBozza: null,
      urlPreview: '/abstracts/1/6.pdf',
      preview: false,
      //options: {},
      autore:{
        id:-1,
        cognome: '',
        nome: '',
        affiliazione:''
      },
      checkTelefono: function (rule, value, callback)  {
       
        if (value.toString()=='') {
           alert('Inserire il numero')
          return callback(new Error('Inserire il numero'));
        }else{
          callback();
        }
      },

      checkAge: function (rule, value, callback)  {
        if (!value) {
          return callback(new Error('Please input the age'));
        }
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('Please input digits'));
          } else {
            if (value < 18) {
              callback(new Error('Age must be greater than 18'));
            } else {
              callback();
            }
          }
        }, 1000);
      },
      
      content: 'prova di messaggio'
    }
  },
  computed: {

    rules:function() {
      console.log(this.$teras.lang.eRequired)
        var rulesNow = {
        premail: [
          { required: true, message: this.$teras.lang.eRequired.premail, trigger: 'blur' },
          { type: 'email', message: this.$teras.lang.eEmail, trigger: 'blur,change' }
        ],
        prcognome: [
          { required: true, message: this.$teras.lang.eRequired.prcognome , trigger: 'blur' }
        ],
        prnome: [
          { required: true, message: this.$teras.lang.eRequired.prnome , trigger: 'blur' }
        ] ,
        paemail: [
          { required: true, message: this.$teras.lang.eRequired.paemail , trigger: 'blur' },
          { type: 'email', message: this.$teras.lang.eEmail , trigger: 'blur,change' }
        ],
        pacellulare: [
          { required: true, validator: this.checkTelefono, message: this.$teras.lang.eRequired.pacellulare , trigger: 'blur' }
        ],
        
        pacodicefiscale: [
          { required: (this.$teras.evento.pacodicefiscale==1), message: this.$teras.lang.eRequired.pacodicefiscale , trigger: 'blur' }
        ],
        
        panato: [
          { required: (this.$teras.evento.panato==1), validator: this.checkAge, message: this.$teras.lang.eRequired.panato , trigger: 'blur,change' }
        ],
        
        pacategoriaprofessionale: [
          { required: (this.$teras.evento.pacategoriaprofessionale==1), type: 'number', message: this.$teras.lang.eRequired.pacategoriaprofessionale , trigger: 'blur,change' }
        ],
        
        paregionelavoro: [
          { required: (this.$teras.evento.paregionelavoro==1), type: 'number', message: this.$teras.lang.eRequired.paregionelavoro , trigger: 'blur,change' }
        ],
        
        panazionelavoro: [
          { required: (this.$teras.evento.panazionelavoro==1), message: this.$teras.lang.eRequired.panazionelavoro , trigger: 'blur,change' }
        ],
        
        paassociazione: [
          { required: (this.$teras.evento.paassociazione!=''), type: 'number', message: this.$teras.lang.eRequired.paassociazione , trigger: 'blur,change' }
        ],
        
        poster: [
          { required: (this.$teras.evento.poster=='1'), type: 'number', message: this.$teras.lang.eRequired.poster , trigger: 'blur,change' }
        ],
        
        topicposter: [
          { required: (this.$abs.row.poster==1 && this.$teras.topicposter.length>0), type: 'number', message: this.$teras.lang.eRequired.topicposter , trigger: 'blur,change' }
        ],
        
        comunicazione: [
          { required: (this.$teras.evento.comunicazione=='1'), type: 'number', message: this.$teras.lang.eRequired.comunicazione , trigger: 'blur,change' }
        ],
        
        topiccomunicazione: [
          { required: (this.$abs.row.comunicazione==1 && this.$teras.topiccomunicazione.length>0), type: 'number', message: this.$teras.lang.eRequired.topiccomunicazione , trigger: 'blur,change' }
        ],
                
        titolo: [
          { required: true, message: this.$teras.lang.eRequired.titolo, trigger: 'blur,change' }
        ],   
                
        parolechiave: [
          { required: (this.$teras.evento.parolechiave==1), message: this.$teras.lang.eRequired.parolechiave, trigger: 'blur,change' }
        ]

        
        }

        if(this.$teras.evento.id==136){
          rulesNow.dmdaltro = [
            { required: (this.$abs.row.poster==1), type: 'number', message: 'Partecipi al Premio della Fondazione è obbligatorio', trigger: 'blur,change' }
          ]
        }

        if(this.$teras.evento.id==177){
          rulesNow.dmdaltro = [
            { required: true, type: 'number', message: 'Scegliere se partecipare ai Premi è obbligatorio', trigger: 'blur,change' }
          ]
        }

        return rulesNow
      },



    form: function(){
        /*
      this.destinatari = (typeof this.$store.state.nl.destinatari != 'undefined') ? this.$store.state.nl.destinatari.split(",") : [];
      if(this.$store.state.nl.destinatari == '') 
        this.destinatari = [];
        */
      return this.$abs.row
    },
  },
  methods: {
    onNew(){
      
      //this.$abs.new().then((response) => {
      this.axios.sessionGet('session_id').then((response) => {  
        console.log("CARICATO NUOVO")
        console.log(response)
        console.log(this.$abs)
      })
      console.log("DOPO NUOVO")


    },
  
    onEnd(){
      console.log(this.$teras.autori[0].cognome)
    },
    onChange(){
      this.$teras.preview = false
      this.preview = false
    },
    onEdit(autore){
      this.autore.id=autore.id
      this.autore.cognome=autore.cognome
      this.autore.nome=autore.nome
      this.autore.affiliazione=autore.affiliazione
    },
    delAutore(){
      for ( const autore of this.$teras.autori){
        //console.log(autore)
        if(autore.id == this.autore.id){
          console.log(this.$teras.autori.indexOf(autore))
          this.$teras.autori.splice(this.$teras.autori.indexOf(autore),1)
          this.autore.id=-1
          this.autore.cognome=''
          this.autore.nome=''
        }
      }
    },
    addAutore(){
      if(this.autore.id<0){
        this.autore.id = this.$teras.autori.length
        this.$teras.autori.push({id:this.autore.id,cognome:this.autore.cognome,nome:this.autore.nome,affiliazione:this.autore.affiliazione})
      }else{
        for (let autore of this.$teras.autori)
        if(autore.id == this.autore.id){
          autore.cognome=this.autore.cognome
          autore.nome=this.autore.nome
          autore.affiliazione=this.autore.affiliazione
        }
      }
      console.log(this.autore)
      console.log(this.$teras.autori.length)
      this.autore.id=-1
      this.autore.cognome=''
      this.autore.nome=''
    },
    
    destinatariChange(){
      console.log(this.destinatari)
    },
    onPreview(event) {
      if(this.$abs.row.comunicazione==0 && this.$abs.row.poster==0){
          this.$notify.error({title: 'Errore', message: 'Bisogna inviare l\'abstract come poster o comunicazione!'})
      }else{
        this.$refs.isAbs.validate((valid) => {
          if (valid ) {
            this.Preview()
          } else {
            this.$notify.error({title: 'Errore', message: 'Non tutti i dati sono stati inseriti correttamente!' })
          }
        })
      }

    },
    Bozza(){
      var parent = this
      var tosave = {
        action: 'bozze',
        browsername: this.$teras.browsername,
        browserversion: this.$teras.browserversion,
        browsertime: this.$teras.minutes,
        evento: this.$teras.evento,
        abstract: this.$abs.row,
        affiliazioni: this.$teras.affiliazioni,
        autori: this.$teras.autori
      }
      this.axios.post('api/abs/bozze/',tosave)
    },
    Preview(){
      var parent = this
      this.$abs.preview().then(()=>{
        console.log("PREVIEW FATTA E FINITA")
        console.log(this.$abs.urlPreview)
        this.$teras.preview = true
      })      
    },
    saveNoEmail(){
      this.$abs.sendnoemail().then(()=>{
        console.log("SEND FATTO E FINITO")
        this.$router.push('/inviato')
      })
    },
    Save(){
      this.$teras.appReady = false
      this.$abs.send().then(()=>{
        console.log("SEND FATTO E FINITO")
        this.$abs.nuovo().then(() => {
          this.$router.push('/inviato')
          this.$teras.appReady = true
        })
      })
    }
  }
}
</script>
<style>
.help{
  
  padding-top:0 !important;
  padding-bottom: 20px !important;
}.help h6{
  color: red;
  font-size:1.6rem;
  line-height:24px;
  padding-left:40px;
}.help di{
  float:left;color: red;
  
}.help div{
  

}.el-checkbox {
    width: 100%;
    margin: 0 !important;
}.dragArea{
  margin: 0 0 20px 180px;
  border:1px solid #bfcbd9;

  border-radius: 4px;
}.dragArea div:first-child{

}.dragArea div{
  cursor:move;
  border-bottom:1px solid #bfcbd9;
  padding:6px 10px;
}.dragArea div:last-child{
  border:none;

}.el-form-item__label{
  font-size: 1.5rem;
  /*text-transform: capitalize; */

}.el-form-item__label{
  width: 16.66% !important;
}.el-form-item__content, .dragArea{
  margin-left: 16.66% !important;

}.s5 .el-form-item__label{
  width: 40.09% !important;
}.s5 .el-form-item__content{
  margin-left: 40.09% !important;


}.s6 .el-form-item__label{
  width: 33.32% !important;
}.s6 .el-form-item__content{
  margin-left: 33.32% !important;

}.s10 .el-form-item__label{
  width: 19.89% !important;
}.s10 .el-form-item__content{
  margin-left: 19.89% !important;


}.formInfo{
  color: #48576a;
  padding: 11px 0 11px 180px;
  font-size: 1.5rem;

}.yesno-label label.el-form-item__label{
  width:auto !important;
  margin:0 !important;
  float:none;
  padding:0 !important;
  line-height:42px !important;

}.yesno-label div.el-form-item__content{
  float:left;
  margin:0 0 0 0 !important;
  width:16.66% !important;
  text-align:right;
  padding-right:10px;

}
</style>


// WEBPACK FOOTER //
// Abs-new.vue?23c91afe